import { motion } from "framer-motion";
import * as LucideIcons from "lucide-react";
import { useI18n, pick } from "@/lib/i18n";
import { useContent } from "@/lib/content";

export default function Benefits() {
  const { lang } = useI18n();
  const { content } = useContent();
  const b = content?.benefits;
  if (!b) return null;
  const header = pick(b, lang, b.ru);
  return (
    <section id="benefits" className="relative py-16 sm:py-20 lg:py-32" data-testid="benefits-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-10 sm:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent text-xs font-semibold mb-4">
            {lang === "ru" ? "Преимущества" : "Benefits"}
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-5xl font-semibold tracking-tight">{header.title}</h2>
          <p className="mt-4 text-base text-muted-foreground">{header.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {(b.items || []).map((it, i) => {
            const Icon = LucideIcons[it.icon] || LucideIcons.Sparkles;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group relative p-5 sm:p-7 lg:p-8 rounded-3xl border border-border bg-card overflow-hidden hover:-translate-y-1.5 transition-transform duration-300 will-change-transform"
                data-testid={`benefit-${i}`}
              >
                <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full bg-primary/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="relative">
                  <div className="size-12 rounded-xl bg-foreground text-background flex items-center justify-center mb-5">
                    <Icon className="size-5" />
                  </div>
                  <h3 className="font-heading text-lg font-semibold mb-2">
                    {lang === "ru" ? it.ru_title : it.en_title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {lang === "ru" ? it.ru_text : it.en_text}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
